<template>
  <div class="addClassDialog">
    <div class="btnview">
      <el-button class="addclass" size="mini" plain @click="openDialog"
        >选择</el-button
      >
    </div>
    <el-dialog
      title="选择排课讲次"
      :visible.sync="addClassDialogVisible"
      width="80%"
      top="10vh"
      append-to-body
    >
      <div class="dialog-body">
        <el-table
          size="mini"
          ref="classTable"
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column width="100" align="center" label="序号">
            <template slot-scope="scope"> {{ scope.$index + 1 }} </template>
          </el-table-column>

          <el-table-column align="left" width="200" label="封面">
            <template slot-scope="scope">
              <el-image
                style="width: 96px; height: 72px; border-radius: 5px"
                :src="scope.row.img_url"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="title"
            label="讲次名称"
          ></el-table-column>

          <el-table-column
            align="left"
            prop="desc"
            label="简介"
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quit">取消</el-button>
        <el-button size="small" type="primary" @click="confirmTo"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassList,
  getCurriculumList,
  getUserTeacher,
  getPrepareCurrculumMaterialList,
} from "@/api/educational";
import { getUserSubjectList } from "@/api/user";
export default {
  name: "addTeachPlan",
  props: {
    curriculum_id: String,
  },
  data() {
    return {
      chooseTeachPlan: [], //教学计划

      addClassDialogVisible: false,
      search_value: "",
      search_type: "1",
      lecturer_id: "",
      subject_id: "",
      teacherList: [],
      curriculum_list: [],
      subjectList: [],
      teacher: "",
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 20,
    };
  },

  watch: {
    curriculum_class_id() {
      console.log("班级ID传过来了");
      console.log(this.curriculum_class_id);
    },
  },

  methods: {
    //根据班级查询教学计划
    getPrepareCurrculumMaterialList() {
      getPrepareCurrculumMaterialList({
        curriculum_id: this.curriculum_id,
      }).then((res) => {
        console.log("返回教学计划");
        console.log(res);
        this.tableData = res.curriculumMaterialList;
      });
    },

    getUserTeacher() {
      getUserTeacher().then((res) => {
        this.teacherList = res.user_list;
      });
    },
    openDialog() {
      console.log("查询教学计划");
      console.log(this.curriculum_id);
      //this.getTchTeachingPlan();
      this.addClassDialogVisible = true;
      this.getPrepareCurrculumMaterialList();
    },
    search() {
      this.page_no = 1;
      this.getClassList();
    },
    reset() {
      this.search_value = "";
      this.teacher = "";
      this.curriculum_id = "";
      this.subject_id = "";
      this.getClassList();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.getClassList();
    },
    // 获取学科
    getUserSubjectList() {
      getUserSubjectList().then((res) => {
        this.subjectList = res.base_platform.concat(res.mechanism_platform);
      });
    },
    // 获取课程体系
    getCurriculumList() {
      getCurriculumList({
        subject_id: this.subject_id,
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list;
      });
    },
    // 获取班级列表
    getClassList() {
      getClassList({
        search_type: this.search_type,
        search_value: this.search_value,
        subject_id: this.subject_id,
        lecturer_id: this.lecturer_id,
        curriculum_id: this.curriculum_id,
        page_no: this.page_no,
      }).then((res) => {
        this.tableData = res.class_list;
        this.total = res.total;
      });
    },
    handleSelectionChange(selection) {
      this.chooseTeachPlan = selection;
      console.log(selection);
    },
    quit() {
      this.search_value = "";
      this.teacher = "";
      this.curriculum_id = "";
      this.subject_id = "";
      this.addClassDialogVisible = false;
    },
    // 确认导入
    confirmTo() {
      console.log("已选的教学计划");
      console.log(this.chooseTeachPlan);

      this.$emit("chooseTeachPlan", this.chooseTeachPlan);
      this.quit();
    },
  },
};
</script>

<style scoped lang="scss">
.addClassDialog {
  .btnview {
    text-align: left;
    .addclass {
      margin-bottom: 0px;
    }
  }
}
</style>